﻿const selector = '[data-countToTarget]';

const INTERVAL_TIME = 10;

const defaultOptions = {
  start: 0,
  end: 100,
  duration: 5000
};

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => countToTarget(element));
})



function countToTarget(element) {
  let settings = { ...defaultOptions, ...JSON.parse(element.dataset.counttotarget) };
  let start = settings.start;
  let end = settings.end;
  let duration = settings.duration;
  if (duration < 100) {
    duration = 100;
  } else if (duration > 10000) {
    duration = 10000;
  }

  let decimals = (end % 1 != 0) ? (end.toString().split('.')[1] || '').length : 0;

  if (end === start) {
    element.innerHTML = start.toFixed(decimals);
    return;
  }

  const stepTime = Math.ceil(duration / INTERVAL_TIME);
  let quantityPerLoop = end / stepTime;

  let increment = (end - start) / stepTime;
  let current = start;

  const INTERVAL = setInterval(() => {
    current += quantityPerLoop;
    element.innerHTML = current.toFixed(decimals);
    if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
      clearInterval(INTERVAL);
      element.innerHTML = parseFloat(end).toFixed(decimals);
    }
  }, INTERVAL_TIME);
}